module.exports = __webpack_public_path__ + "c5559e491ed3276c457d23f8fbede563.png";